import BrowserDetector from '@/scripts/helpers/browser-detector';
import urlLocationHelper from '@/scripts/helpers/url-location-helper';
import loginController from '@/scripts/libs/login/controller';
import { VideoStoreActionContext } from './initializer';
import { VideoOverlayType, VideoOverlayPriority } from '../state/VideoOverlay';

export const controlAppGateDisplay = async({ commit }: VideoStoreActionContext): Promise<void> => {
  if (!BrowserDetector.md().phone()) return;

  if (await loginController.getUser()) return;

  const query = urlLocationHelper.query.parse();

  const utmCampaign = query['utm_campaign'];
  if (utmCampaign && utmCampaign.startsWith('paid-')) {
    // Skip
    return;
  }

  commit('addVideoPlayerOverlay', {
    name: 'AppGateOverlay',
    type: VideoOverlayType.Dismissable,
    priority: VideoOverlayPriority.Info,
  });
};
